import { render } from "./ModalSubmitBatch.vue?vue&type=template&id=a45dcaec&bindings={}"
import script from "./ModalSubmitBatch.vue?vue&type=script&lang=ts"
export * from "./ModalSubmitBatch.vue?vue&type=script&lang=ts"

import "./ModalSubmitBatch.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script